/* eslint-disable no-unused-vars */
import React from "react";

export default function setCookie(key: string, value: string, days: number) {
  const now = new Date();
  now.setDate(now.getDate() + days);
  const expires = `expires=${now.toUTCString()}`;
  const temp = `${key}=${value}; ${expires}`;
  document.cookie = temp;
}
